// NOTE: "The amount value supports up to eight digits (e.g., a value of 99999999 for a USD charge of $999,999.99)." (https://stripe.com/docs/api/charges/object#charge_object-amount)
export const PRODUCT_PRICE_MAX = 999999.99;
// export const PRODUCT_PROFIT_MIN = 3
export const DIGITAL_PRODUCTS_FEE_PERCENTAGE = 3;
export const SINGLE_UNIT_PRODUCT_ORDER_SHIPPING_FEES = 5.99;
export const SINGLE_UNIT_PRODUCT_ORDER_TAXES_FEES = 1.99;
export const SINGLE_UNIT_PRODUCT_PAYMENT_PROCESSING_FEE_VALUE = 0.3;
export const SINGLE_UNIT_PRODUCT_PAYMENT_PROCESSING_FEE_PERCENT = 2.9;
